<template>
  <div class="login-form w-full">
    <form id="loginForm" @submit.prevent="submitLogin" class="mt-10">
      <div>
        <div class="mb-4">
          <CustomInput
            type="email"
            id="email"
            placeholder="Enter email"
            v-model="email"
            :hasError="emailError"
            required
          />
        </div>
        <div>
          <CustomInput
            type="password"
            id="password"
            placeholder="Password"
            v-model="password"
            :hasError="passwordError"
            required
          />
        </div>
      </div>

      <div class="text-right text-white mt-2">
        <router-link :to="{ name: 'Forgot Password' }" class="forgot-password">
          Forgot password
        </router-link>
      </div>

      <div v-if="props.errorMessage" class="mt-10 text-center text-red-600">
        <span
          ><em class="fa-solid fa-circle-exclamation mr-1"></em
          >{{ props.errorMessage }}</span
        >
      </div>

      <div class="form-actions">
        <div class="text-center text-white mt-6 mb-2">
          <div class="mb-1">New on {{ appName }}?</div>
          <div class="flex items-center justify-center">
            <div class="flex-1 text-right pr-2">
              <router-link style="color: #f7bf43" :to="{ name: 'SignUp' }">
                Create a new account
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps, computed } from "vue";
import { useRoute } from "vue-router";
import CustomInput from "@/components/general/CustomInput.vue";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();

const emit = defineEmits(["loginEvent", "updateEmail", "updateErrorMessage"]);
const props = defineProps({
  errorMessage: {
    type: String,
  },
  userEmail: {
    type: String,
    default: "",
  },
});

const email = ref(null);
const password = ref(null);
const emailError = ref(false);
const passwordError = ref(false);

const appName = computed(() => store.getters["location/getAppName"]);

watch(
  () => props.errorMessage,
  (newValue) => {
    if (newValue) {
      setTimeout(() => {
        emit("updateErrorMessage", "");
      }, 2000);
    }
  }
);

watch(
  () => props.userEmail,
  (newValue) => {
    email.value = newValue || null;
  },
  { immediate: true }
);

watch(email, (newValue) => {
  emit("updateEmail", newValue);
  emailError.value = false;
});

watch(password, (newValue) => {
  passwordError.value = false;
});

function submitLogin() {
  const redirectPath = route.query.redirect || "";

  emailError.value = !email.value;
  passwordError.value = !password.value;

  if (email.value && password.value) {
    return emit("loginEvent", email.value, password.value, redirectPath);
  }
}
</script>
